// extracted by mini-css-extract-plugin
export var childrenContainer = "_17-0";
export var virtualScrollArea = "_17-1";